<template>
  <div>
    <el-table :header-cell-style="cellStyle" :data="tableData" style="margin-top: 10px" size="normal" border :span-method="spanMethod">
      <slot></slot>
      <el-table-column align="center" v-for="col in columnData" :key="col.prop" :class-name="col.setBg ? 'set-bg' : ''" :prop="col.prop" :label="col.label" :formatter="(row) => row[col.prop] || '/'" :width="col.width || 'auto'">
        <template slot-scope="scope">
          <div style="position: relative" v-if="col.prop === 'billingUnit' && (scope.row[col.prop] === '托' ||　scope.row[col.prop] === '箱')">
            <span>{{scope.row[col.prop]}}</span>
            <el-tooltip :content="`${scope.row.billingLinkName || '/'}: ${scope.row.billingLinkLength || ''}M*${scope.row.billingLinkWidth || ''}M*${scope.row.billingLinkHeight || ''}M`" placement="top" effect="dark">
              <i style="" class="el-icon-question"></i>
            </el-tooltip>
          </div>
          <template v-else-if="col.prop.includes('price')">
            {{scope.row[col.prop] ? scope.row[col.prop].toFixed(2) : '/'}}
          </template>
          <template v-else>{{scope.row[col.prop] || '/'}}</template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    spanMethod: {
      type: Function
    },
    tableData: {
      type: Array,
      default: () => []
    },
    columnData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      cellStyle: {background: '#F9F9F9', color: '#141414', fontWeight: 'bold'},
    }
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .set-bg {
    background: #F9F9F9;
    color: #141414;
    font-weight: 500
  }
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/globalCloudWareQuotation/coast-table-normal.vue